import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { BILLING, EDIT, ROLE_ADMIN, ROLE_VIEWER, SETTINGS, VIEW } from "./Permissions";

const cookieDomain = process.env.REACT_APP_COOKIE_HOST;
const removeCookieOptions = { path: "/", domain: cookieDomain };

const userAccessTokenCookieName = "userAccessToken";
const userRefreshTokenCookieName = "userRefreshToken";
const providerNameCookieName = "providerName";
const redirectOnLoginCookieName = "redirectOnLogin";
const redirectOnLogoutCookieName = "redirectOnLogout";
class TokenService {
    getUserName() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            return decoded.email;
        } else {
            return "";
        }
    }

    getProviderName() {
        var providerName = Cookies.get(providerNameCookieName);
        if (!providerName) {
            var token = Cookies.get(userRefreshTokenCookieName);
            if (token) {
                var decoded = jwtDecode(token);
                var pn = decoded.provName;
                var refreshTokenExpirationTime = 1000 * 60 * 60 * 24 * 7; // 7 days
                var inSevenDays = new Date(new Date().getTime() + refreshTokenExpirationTime);
                const refreshTokenCookieOptions = {
                    path: "/",
                    secure: true,
                    expires: inSevenDays,
                    domain: cookieDomain,
                };
                Cookies.set(providerNameCookieName, pn, refreshTokenCookieOptions);
                return pn;
            } else {
                return "";
            }
        }
        return providerName;
    }

    getProviderVanityUrl() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            if (!decoded.provVan || decoded.provVan === "") {
                return null;
            }
            return decoded.provVan;
        } else {
            return null;
        }
    }

    getProviderSubdomain() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            if (!decoded.provSub || decoded.provSub === "") {
                return null;
            }
            return decoded.provSub;
        } else {
            return null;
        }
    }

    getProviderUrl() {
        return process.env.REACT_APP_PROVIDER_SITE + "/provider/" + this.getProviderSubdomain();
    }

    setAccessToken(token) {
        const accessTokenExpirationTime = 15 * 60 * 1000; // 15 minutes
        var inFifteenMinutes = new Date(new Date().getTime() + accessTokenExpirationTime);
        const accessTokenCookieOptions = {
            path: "/",
            secure: true,
            expires: inFifteenMinutes,
            domain: cookieDomain,
        };
        Cookies.set(userAccessTokenCookieName, token, accessTokenCookieOptions);
    }

    setRefreshToken(token) {
        var refreshTokenExpirationTime = 1000 * 60 * 60 * 24 * 7; // 7 days
        var inSevenDays = new Date(new Date().getTime() + refreshTokenExpirationTime);
        const refreshTokenCookieOptions = {
            path: "/",
            secure: true,
            expires: inSevenDays,
            domain: cookieDomain,
        };
        var decoded = jwtDecode(token);
        var pn = decoded.provName;
        Cookies.set(providerNameCookieName, pn, refreshTokenCookieOptions);
        Cookies.set(userRefreshTokenCookieName, token, refreshTokenCookieOptions);
    }

    isAuthenticated() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            return true;
        }
        return false;
    }

    isLoggedIn() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            var emailVerified = decoded.ev;
            if (emailVerified === "true") {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }

    isWallistAdmin() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            var emailVerified = decoded.ev;
            if (emailVerified === "true") {
                var email = decoded.email.trim();
                if (email.endsWith("@wallist.com")) {
                    var sa = decoded.sa;
                    if (sa === "true") {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                return false;
            }
            else {
                return false;
            }
        }
        return false;
    }

    isPendingEmailVerification() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            var emailVerified = decoded.ev;
            if (emailVerified === "false") {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }

    isLoggedIntoProvider() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            if (decoded.provSub) {
                return true;
            }
        }
        return false;
    }

    logoutUser() {
        Cookies.remove(userAccessTokenCookieName, removeCookieOptions);
        Cookies.remove(userRefreshTokenCookieName, removeCookieOptions);
        Cookies.remove(providerNameCookieName, removeCookieOptions);
    }

    getUserAccessToken() {
        return Cookies.get(userAccessTokenCookieName);
    }

    getRedirectOnLogin() {
        var url = Cookies.get(redirectOnLoginCookieName);
        if (url && url !== "") {
            if (url.startsWith(process.env.REACT_APP_PUBLIC_SITE + "/")) {
                return url;
            }
            else if (url.startsWith(process.env.REACT_APP_ID_SITE + "/")) {
                return url;
            }
            else if (url.startsWith(process.env.REACT_APP_PROVIDER_SITE + "/")) {
                return url;
            }
            else if (url.startsWith(process.env.REACT_APP_NETWORK_SITE + "/")) {
                return url;
            }
            else {
                return null;
            }
        }
        return null;
    }

    getRedirectOnLogout() {
        var url = Cookies.get(redirectOnLogoutCookieName);
        if (url && url !== "") {
            if (url.startsWith(process.env.REACT_APP_PUBLIC_SITE + "/")) {
                return url;
            }
            else if (url.startsWith(process.env.REACT_APP_ID_SITE + "/")) {
                return url;
            }
            else if (url.startsWith(process.env.REACT_APP_PROVIDER_SITE + "/")) {
                return url;
            }
            else if (url.startsWith(process.env.REACT_APP_NETWORK_SITE + "/")) {
                return url;
            }
            else {
                return null;
            }
        }
        return null;
    }

    removeRedirectOnLogout() {
        Cookies.remove(redirectOnLogoutCookieName, removeCookieOptions);
    }

    redirectUser(providerCount) {
        var redirectUrl = this.getRedirectOnLogin();
        if (redirectUrl) {
            // They are in a process (e.g. profile claiming) and need to redirect to complete the flow
            Cookies.remove(redirectOnLoginCookieName, removeCookieOptions);
            window.location.href = redirectUrl;
        }
        else {
            if (this.getProviderSubdomain()) {
                // They only have 1 provider and auto-logged in
                window.location.href = this.getProviderUrl();
            }
            else {
                if (providerCount > 1) {
                    // they have more than 1 provider so they need to pick
                    window.location.href = process.env.REACT_APP_ID_SITE + "/account/select-provider";
                }
                else {
                    // they don't have a provider yet
                    window.location.href = process.env.REACT_APP_ID_SITE + "/welcome";
                }
            }
        }
    }

    getPublicProfileName() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            if (decoded.fn && decoded.ln) {
                return decoded.fn + " " + decoded.ln.charAt(0);
            }
            else {
                return "";
            }
        } else {
            return "";
        }
    }

    getFirstName() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            return decoded.fn;
        } else {
            return "";
        }
    }

    getLastName() {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            return decoded.ln;
        } else {
            return "";
        }
    }

    hasAccess(section, feature, action) {
        var token = Cookies.get(userRefreshTokenCookieName);
        if (token) {
            var decoded = jwtDecode(token);
            var roles = null;
            if (section.startsWith('b')) {
                roles = decoded.br;
            }
            else if (section.startsWith('p')) {
                roles = decoded.pr;
            }
            if (roles) {
                let items = roles.split(',').map(item => item.trim());
                if (items.includes(ROLE_ADMIN)) {
                    return true;
                }
                else {
                    if (items.includes(ROLE_VIEWER)) {
                        if (action === VIEW) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }

    isImpersonating() {
        if (this.isWallistAdmin() && !this.hasAccess(BILLING, SETTINGS, EDIT)) {
            return true;
        }
        else {
            return false;
        }
    }

    setRedirectOnLogin(url) {
        const expirationTime = 60 * 60 * 1000 * 24 * 3; // 72 hours
        var inThreeDays = new Date(new Date().getTime() + expirationTime);
        const cookieOptions = {
            path: "/",
            secure: true,
            expires: inThreeDays,
            domain: cookieDomain,
        };
        Cookies.set(redirectOnLoginCookieName, url, cookieOptions);
    }
}

export default new TokenService();
